<template>
  <div class="row mt-3">
    <div class="col-md-9">
      <p class="font-weight-bold">
        Anotações sobre a presença de animais de estimação
      </p>
    </div>

    <!--
    Regra temporariamente desativada:
    v-if="
      item.estado_cadastral_id != 4 &&
      item.estado_cadastral_id != 5
    "
    -->

    <div
      class="col-md-3 text-right"
    >
      <button
        class="btn btn-sm btn-primary"
        @click="$bvModal.show('add-animais')"
      >
        <i class="fas fa-plus-square" />
        {{ $t("Cadastrar") }}
      </button>
    </div>
    <div class="col-md-12">
      <div v-if="item.animais.length == 0">
        <h4 class="text-secondary">
          <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
          A familia não possui animais de estimação.
        </h4>
      </div>
      <table v-else class="table table-striped">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Especie</th>
            <th>Sexo</th>
            <th>Castrado</th>
            <th>Data</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(animal, index) in item.animais" :key="animal.id">
            <td>{{ animal.nome }}</td>
            <td>{{ animal.especie }}</td>
            <td>{{ animal.sexo }}</td>
            <td>{{ animal.castrado }}</td>
            <td>{{ animal.created_at }}</td>
            <td>
              <b-button
                :title="$t('Excluir')"
                :class="'px-2 mb-0 btn-excluir-' + animal.id"
                size="xs"
                type="button"
                v-b-tooltip.hover
                variant="danger"
                data-style="zoom-in"
                @click.prevent="deleteAnimal(animal.id, index)"
              >
                <i class="mdi mdi-delete-forever" />
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ModalAddAnimais :item="item" />
  </div>
</template>
<script>
import ModalAddAnimais from "./ModalAddAnimais";
export default {
  components: {
    ModalAddAnimais,
  },
  props: ["item"],
  methods: {
    deleteAnimal(id, index) {
      let ladda = Ladda.create(document.querySelector(".btn-excluir-" + id));
      ladda.start();
      axios
        .get(`api/dashboard/familias/animal/delete/${id}`)
        .then((response) => {
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.item.animais.splice(index, 1);
          ladda.stop();
        })
        .catch(() => ladda.stop());
    },
  },
};
</script>
